export const checkInternetConnection = () => {
  if (navigator.onLine) {
    return true;
  } else {
    return false;
  }
};
